import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  FolderOpen, MessageSquare, Network, GraduationCap, FileCheck,
  BookOpen, Fingerprint, ClipboardList, ShieldCheck, Lock, UserCircle, LayoutDashboard,
  Smartphone, X, Shield, HardHat, ExternalLink, ChevronLeft, ChevronRight, IdCard, Briefcase,
  Phone, Mail, Siren, AlertCircle
} from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const SGES_URL = 'https://www.sges.cl/';
const ACRED_LABORAL_URL = 'https://lomasbayas.acreditacionsercol.cl';

// id 'sges' y 'acred_lab' son externos; el resto son modulos TystaCore (ids numericos)
const MODULES = [
  {
    id: 1, name: 'Carpeta de Arranque',
    desc: ['Proceso Acreditación de Carpetas de Arranque NUEVAS', 'Proceso Extensiones de Servicio.'],
    icon: FolderOpen, color: '#E6A817', ring: '#E6A817',
    externalUrl: 'https://arranque.tysta.cl/',
    category: 'acreditacion',
    areaResponsable: 'Superintendencia HS',
    contactos: [
      { nombre: 'Natalia Contreras', telefono: '+56 9 4020 8947', email: 'Natalia.Contreras@glencore.cl' },
      { nombre: 'Antonella Mella', telefono: '+56 9 6518 6217', email: 'Antonella.Mella@glencore.cl' },
    ],
  },
  {
    id: 'sges', name: 'SGES',
    desc: ['Ingreso de CARTA DE INICIO DE ACTIVIDADES', 'Ingreso E-200'],
    icon: Shield, color: '#0F766E', ring: '#0F766E',
    externalUrl: SGES_URL,
    category: 'acreditacion',
    areaResponsable: 'Superintendencia HS',
    contactos: [
      { nombre: 'Liviana Ratti', telefono: '+56 9 9255 0778', email: 'livania.ratti@sges.cl' },
      { nombre: 'Sergio Gonzalez', telefono: '+56 9 9543 6444', email: 'sergio.gonzalez@sges.cl' },
    ],
  },
  {
    id: 'acred_lab', name: 'Acreditacion Laboral',
    desc: 'Plataforma de acreditacion laboral Lomas Bayas (Sercol).',
    icon: IdCard, color: '#B45309', ring: '#B45309',
    externalUrl: ACRED_LABORAL_URL,
    category: 'acreditacion',
    areaResponsable: 'Gerencia Personal - Área Laboral',
    empresaResponsable: 'SERCOL',
    contactos: [
      { nombre: 'Javier Ayala', telefono: '+56 9 3370 5376', email: 'jayala@sercol.cl' },
      { nombre: 'Mario Chuy', telefono: '+56 9 3199 3414', email: 'mchuy@sercol.cl' },
      { nombre: 'Correo general', email: 'acreditacion.cmlb@sercol.cl' },
    ],
  },
  {
    id: 4, name: 'Inducción Lomas Bayas y Capacitaciones',
    desc: ['Inscripción a la Inducción de Lomas Bayas', 'Inscripción al Curso de Conducción', 'Cursos Específicos Seguridad y Salud'],
    icon: GraduationCap, color: '#1B919B', ring: '#1B919B',
    route: '/portal/dashboard',
    category: 'acreditacion',
    areaResponsable: 'Superintendencia HS',
    contactos: [
      { nombre: 'Natalia Contreras', telefono: '+56 9 4020 8947', email: 'Natalia.Contreras@glencore.cl' },
      { nombre: 'Antonella Mella', telefono: '+56 9 6518 6217', email: 'Antonella.Mella@glencore.cl' },
    ],
  },
  {
    id: 12, name: 'Repositorio HS',
    desc: 'Biblioteca documental: Estándares de Lomas Bayas, Protocolos de Fatalidad, Reglamentos, cartillas controles críticos y otros documentos.',
    icon: BookOpen, color: '#DB2777', ring: '#DB2777',
    externalUrl: 'https://arranque.tysta.cl/web/?pass=R2dFdERnNENLQWdESFJFK0Z3UUJCaDBQVWw0PQ==',
    category: 'acreditacion',
    areaResponsable: 'Superintendencia HS',
  },
  {
    id: 2, name: 'GCOM',
    desc: 'Comunicacion efectiva y trazabilidad de la gestion operativa.',
    icon: MessageSquare, color: '#D35400', ring: '#D35400',
    externalUrl: 'https://arranque.tysta.cl/acceso_gcom',
    category: 'operacion_hs',
    areaResponsable: 'Superintendencia HS',
    contactos: [
      { nombre: 'Asesor HS en turno' },
    ],
  },
  {
    id: 3, name: 'Organigrama Corporativo',
    desc: 'Control Dotaciones, Jerarquías y Dependencias.',
    icon: Network, color: '#5B7D9A', ring: '#5B7D9A',
    route: '/organizacion',
    category: 'operacion_hs',
  },
  {
    id: 5, name: 'Control Documental',
    desc: 'Gobernanza documental y trazabilidad legal por área y gerencia.',
    icon: FileCheck, color: '#6B8E8E', ring: '#6B8E8E',
    category: 'operacion_hs',
  },
  {
    id: 6, name: 'APP Pase Digital',
    desc: 'Identidad laboral y de seguridad inteligente.',
    subdesc: 'Descargala en App Store y Google Play',
    icon: Fingerprint, color: '#6C3D8E', ring: '#6C3D8E',
    isApp: true,
    category: 'acreditacion',
  },
  {
    id: 7, name: 'Planificador HS',
    desc: 'Liderazgo visible en seguridad y salud ocupacional.',
    icon: ClipboardList, color: '#a05e49', ring: '#a05e49',
    category: 'operacion_hs',
  },
  {
    id: 8, name: 'Checklist Digital',
    desc: 'Cultura preventiva y control operativo.',
    icon: ShieldCheck, color: '#2E7D32', ring: '#2E7D32',
    category: 'operacion_hs',
  },
  {
    id: 11, name: 'HS Safework',
    desc: 'Reportabilidad de Eventos y Programa de Liderazgo.',
    icon: Siren, color: '#0E7490', ring: '#0E7490',
    isExternal: true,
    externalUrl: 'https://sglomas.sam.glencore.net/Login.aspx',
    category: 'operacion_hs',
    areaResponsable: 'Superintendencia HS',
    contactos: [
      { nombre: 'Edwin Pizarro', telefono: '+56 9 7132 1824', email: 'Edwin.Pizarro@glencore.cl' },
      { nombre: 'Asesores HS en turno' },
    ],
  },
  {
    id: 10, name: 'Perfil del Trabajador',
    desc: 'Informacion personal, cargo, capacitaciones y certificaciones.',
    icon: UserCircle, color: '#4A6FA5', ring: '#4A6FA5',
    isProfile: true,
    category: 'operacion_hs',
  },
  {
    id: 9, name: 'Centro Integrado de Datos',
    desc: 'Dashboards consolidados de todos los modulos de TystaCore.',
    icon: LayoutDashboard, color: '#7C3AED', ring: '#7C3AED',
    category: 'operacion_hs',
  },
  {
    id: 13, name: 'Reporte de Incidente',
    desc: 'Reporta incidentes de Seguridad y Salud, Medio Ambiente, Peligros y otros.',
    icon: AlertCircle, color: '#DC2626', ring: '#DC2626',
    route: '/incidentes',
    category: 'operacion_hs',
  },
];

export default function RoleSelector() {
  const { user, selectRole, token, logout } = useAuth();
  const navigate = useNavigate();
  const [logoImage, setLogoImage] = useState(() => localStorage.getItem('cached_logo_url'));
  const [showAppModal, setShowAppModal] = useState(false);
  const [section, setSection] = useState(null); // null | 'acreditacion' | 'operacion_hs'

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const res = await axios.get(`${API}/configuracion`, { headers: { Authorization: `Bearer ${token}` } });
        if (res.data.logo_image) {
          let imgUrl = res.data.logo_image;
          if (!imgUrl.startsWith('http') && !imgUrl.startsWith('data:'))
            imgUrl = `${process.env.REACT_APP_BACKEND_URL}${imgUrl}`;
          setLogoImage(imgUrl);
          localStorage.setItem('cached_logo_url', imgUrl);
        }
      } catch {}
    };
    if (!logoImage) fetchLogo();
  }, [token, logoImage]);

  const userRole = user?.rol || '';
  const isPlanificador = user?.es_planificador;
  const userModules = user?.modules || [];
  const modulesLoaded = user?.modules !== undefined;

  const canAccess = (mod) => {
    if (mod.isApp) return true;
    // Admin/planificador: acceso total a todo
    if (userRole !== 'trabajador') return true;
    // Modulos externos sin gestion en BD (links publicos de Acreditacion)
    if (mod.id === 'sges' || mod.id === 'acred_lab') return true;
    // Trabajador: BD = unica fuente de verdad. La pagina de Gestion de Usuarios manda.
    return userModules.includes(mod.id);
  };

  const handleSelect = (mod) => {
    if (!canAccess(mod)) return;
    if (mod.isApp) {
      setShowAppModal(true);
      return;
    }
    if (mod.externalUrl) {
      window.open(mod.externalUrl, '_blank');
      return;
    }
    if (mod.id === 7) {
      navigate('/liderazgo-viewer');
    } else if (mod.id === 4) {
      navigate('/capacitacion-viewer');
    } else if (mod.id === 3) {
      navigate('/organigrama-viewer');
    } else if (mod.id === 5) {
      navigate('/documentos-viewer');
    } else if (mod.id === 8) {
      navigate('/herramientas-viewer');
    } else if (mod.id === 9) {
      navigate('/centro-datos');
    } else if (mod.id === 10) {
      navigate('/perfil-viewer');
    } else if (mod.id === 13) {
      navigate('/incidentes');
    } else if (mod.route) {
      selectRole(null);
      navigate(mod.route);
    }
  };

  const nombre = user?.nombre || '';

  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'linear-gradient(135deg, #1a5c3a 0%, #1B919B 50%, #1a5c3a 100%)' }}>
      <div className="flex-1 flex flex-col items-center justify-start p-4 pt-6">
        {/* Logo top-right */}
        <div className="w-full max-w-5xl flex justify-end mb-2">
          {logoImage ? (
            <img src={logoImage} alt="Logo" className="h-16 object-contain" style={{ filter: 'brightness(0) invert(1)' }}
              onError={() => { setLogoImage(null); localStorage.removeItem('cached_logo_url'); }}
              data-testid="role-selector-logo" />
          ) : (
            <span className="text-xl font-bold text-white tracking-tight">Lomas Bayas</span>
          )}
        </div>

        {/* Header */}
        <div className="text-center mb-6">
          <h1 className="text-xl font-bold text-white">Bienvenido, {nombre}</h1>
          <p className="text-sm text-white/60 mt-1">Modulos del Sistema Integrado <span className="font-semibold text-white">TYSTA CORE</span> - Superintendencia HS</p>
          <button onClick={() => { logout(); navigate('/login'); }}
            className="mt-3 text-xs text-white/50 hover:text-white underline underline-offset-2 transition-colors"
            data-testid="btn-volver-login">Cerrar sesion</button>
        </div>

        {/* Section selector (primary menu) */}
        {section === null && (
          <div className="w-full max-w-5xl" data-testid="section-selector">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* ========== ACREDITACION ========== */}
              <button
                onClick={() => setSection('acreditacion')}
                className="group relative overflow-hidden rounded-3xl bg-white text-left transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_25px_60px_-15px_rgba(180,83,9,0.4)]"
                data-testid="section-acreditacion"
                style={{ boxShadow: '0 15px 40px -10px rgba(0,0,0,0.25)' }}
              >
                {/* Top gradient banner */}
                <div className="h-2 w-full" style={{ background: 'linear-gradient(90deg, #F59E0B 0%, #B45309 100%)' }} />

                {/* Decorative orb */}
                <div
                  className="absolute -right-16 -top-16 w-64 h-64 rounded-full opacity-10 transition-opacity duration-500 group-hover:opacity-20"
                  style={{ background: 'radial-gradient(circle, #B45309 0%, transparent 70%)' }}
                />

                <div className="relative p-7">
                  {/* Header row: icon + number */}
                  <div className="flex items-start justify-between mb-5">
                    <div
                      className="w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3"
                      style={{ background: 'linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)' }}
                    >
                      <IdCard className="w-8 h-8" style={{ color: '#B45309' }} strokeWidth={2.2} />
                    </div>
                    <span className="text-[10px] font-bold tracking-[0.2em] uppercase px-2.5 py-1 rounded-full" style={{ backgroundColor: '#FEF3C7', color: '#B45309' }}>
                      Seccion 01
                    </span>
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold mb-1.5" style={{ color: '#78350F' }}>Acreditacion</h3>
                  <div className="h-0.5 w-12 mb-3 rounded-full" style={{ background: 'linear-gradient(90deg, #F59E0B 0%, transparent 100%)' }} />

                  <p className="text-sm text-slate-600 leading-relaxed mb-5">
                    Procesos de <b className="text-slate-800">onboarding</b>, documentacion laboral y habilitacion en faena.
                  </p>

                  {/* Modules list */}
                  <div className="space-y-1.5 mb-5">
                    {[
                      { n: '1', name: 'Carpeta de Arranque', color: '#E6A817' },
                      { n: <ExternalLink className="w-3 h-3" />, name: 'SGES', color: '#0F766E', ext: true },
                      { n: <ExternalLink className="w-3 h-3" />, name: 'Acreditacion Laboral', color: '#B45309', ext: true },
                      { n: '4', name: 'Inducción Lomas Bayas y Capacitaciones', color: '#1B919B' },
                      { n: '6', name: 'APP Pase Digital', color: '#6C3D8E' },
                      { n: '12', name: 'Repositorio HS', color: '#DB2777', ext: true },
                    ].map((m, i) => (
                      <div key={i} className="flex items-center gap-2 text-xs">
                        <span
                          className="w-5 h-5 rounded-md flex items-center justify-center font-bold text-[10px] shrink-0"
                          style={{ backgroundColor: `${m.color}15`, color: m.color }}
                        >{m.n}</span>
                        <span className="text-slate-700 font-medium">{m.name}</span>
                        {m.ext && <span className="text-[9px] text-slate-400 italic">· externo</span>}
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <div
                    className="flex items-center justify-between rounded-xl px-4 py-3 transition-all duration-300 group-hover:shadow-md"
                    style={{ background: 'linear-gradient(135deg, #FEF3C7 0%, #FED7AA 100%)' }}
                  >
                    <span className="text-sm font-bold" style={{ color: '#78350F' }}>Ingresar al modulo</span>
                    <div className="w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 group-hover:translate-x-1 shadow-sm" style={{ backgroundColor: '#B45309' }}>
                      <ChevronRight className="w-4 h-4 text-white" strokeWidth={3} />
                    </div>
                  </div>
                </div>
              </button>

              {/* ========== OPERACION HS ========== */}
              <button
                onClick={() => setSection('operacion_hs')}
                className="group relative overflow-hidden rounded-3xl bg-white text-left transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_25px_60px_-15px_rgba(27,145,155,0.5)]"
                data-testid="section-operacion"
                style={{ boxShadow: '0 15px 40px -10px rgba(0,0,0,0.25)' }}
              >
                <div className="h-2 w-full" style={{ background: 'linear-gradient(90deg, #14b8a6 0%, #1B919B 50%, #1a5c3a 100%)' }} />

                <div
                  className="absolute -right-16 -top-16 w-64 h-64 rounded-full opacity-10 transition-opacity duration-500 group-hover:opacity-20"
                  style={{ background: 'radial-gradient(circle, #1B919B 0%, transparent 70%)' }}
                />

                <div className="relative p-7">
                  <div className="flex items-start justify-between mb-5">
                    <div
                      className="w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-3"
                      style={{ background: 'linear-gradient(135deg, #CCFBF1 0%, #99F6E4 100%)' }}
                    >
                      <HardHat className="w-8 h-8" style={{ color: '#0F766E' }} strokeWidth={2.2} />
                    </div>
                    <span className="text-[10px] font-bold tracking-[0.2em] uppercase px-2.5 py-1 rounded-full" style={{ backgroundColor: '#CCFBF1', color: '#0F766E' }}>
                      Seccion 02
                    </span>
                  </div>

                  <h3 className="text-2xl font-bold mb-1.5" style={{ color: '#134e4a' }}>Operacion HS</h3>
                  <div className="h-0.5 w-12 mb-3 rounded-full" style={{ background: 'linear-gradient(90deg, #14b8a6 0%, transparent 100%)' }} />

                  <p className="text-sm text-slate-600 leading-relaxed mb-5">
                    Gestion operativa de <b className="text-slate-800">Seguridad y Salud</b> en faena: organigrama, liderazgo, checklists y datos.
                  </p>

                  <div className="space-y-1.5 mb-5">
                    {[
                      { n: '2', name: 'GCOM', color: '#D35400' },
                      { n: '3', name: 'Organigrama Corporativo', color: '#5B7D9A' },
                      { n: '5', name: 'Control Documental', color: '#6B8E8E' },
                      { n: '7', name: 'Planificador HS', color: '#a05e49' },
                      { n: '8', name: 'Checklist Digital', color: '#2E7D32' },
                      { n: '9', name: 'Centro Integrado de Datos', color: '#7C3AED' },
                      { n: '11', name: 'HS Safework', color: '#0E7490', ext: true },
                      { n: '10', name: 'Perfil del Trabajador', color: '#4A6FA5' },
                    ].map((m, i) => (
                      <div key={i} className="flex items-center gap-2 text-xs">
                        <span
                          className="w-5 h-5 rounded-md flex items-center justify-center font-bold text-[10px] shrink-0"
                          style={{ backgroundColor: `${m.color}15`, color: m.color }}
                        >{m.n}</span>
                        <span className="text-slate-700 font-medium">{m.name}</span>
                      </div>
                    ))}
                  </div>

                  <div
                    className="flex items-center justify-between rounded-xl px-4 py-3 transition-all duration-300 group-hover:shadow-md"
                    style={{ background: 'linear-gradient(135deg, #CCFBF1 0%, #A7F3D0 100%)' }}
                  >
                    <span className="text-sm font-bold" style={{ color: '#134e4a' }}>Ingresar al modulo</span>
                    <div className="w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 group-hover:translate-x-1 shadow-sm" style={{ backgroundColor: '#0F766E' }}>
                      <ChevronRight className="w-4 h-4 text-white" strokeWidth={3} />
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </div>
        )}

        {/* Modules Grid */}
        {section !== null && (
        <div className="w-full max-w-5xl" data-testid="role-selector">
          <div className="mb-3 flex items-center justify-between">
            <button
              onClick={() => setSection(null)}
              className="inline-flex items-center gap-1 text-xs text-white/80 hover:text-white underline underline-offset-2"
              data-testid="volver-secciones"
            >
              <ChevronLeft className="w-3.5 h-3.5" /> Volver al menu principal
            </button>
            <span className="text-xs text-white/80 font-semibold uppercase tracking-wide">
              {section === 'acreditacion' ? 'Acreditacion' : 'Operacion HS'}
            </span>
          </div>
          <div className={`grid grid-cols-1 gap-4 items-stretch ${section === 'acreditacion' ? 'md:grid-cols-3' : 'md:grid-cols-3'}`}>
            {MODULES.filter(m => m.category === section).map(mod => {
              const Icon = mod.icon;
              const accessible = canAccess(mod);
              const isWide = mod.id === 10 || mod.id === 9;
              return (
                <button key={mod.id} onClick={() => handleSelect(mod)}
                  disabled={!accessible && !mod.isApp}
                  className={`flex ${isWide ? 'flex-row gap-4 md:col-span-3 h-auto py-3 px-6' : 'flex-col gap-2.5 min-h-[160px] justify-start'} items-center rounded-xl border-2 transition-all text-center p-4 ${
                    accessible
                      ? 'bg-white border-white/80 hover:shadow-xl hover:scale-[1.01] cursor-pointer'
                      : 'bg-white/10 border-white/20 backdrop-blur-sm cursor-not-allowed'
                  }`}
                  onMouseEnter={e => { if (accessible) e.currentTarget.style.borderColor = mod.ring; }}
                  onMouseLeave={e => { if (accessible) e.currentTarget.style.borderColor = accessible ? 'rgba(255,255,255,0.8)' : 'rgba(255,255,255,0.2)'; }}
                  data-testid={`module-${mod.id}`}>
                  <div className="relative">
                    <div className={`${isWide ? 'w-11 h-11' : 'w-12 h-12'} rounded-full border-[3px] flex items-center justify-center`}
                      style={{ borderColor: accessible ? mod.ring : 'rgba(255,255,255,0.3)', backgroundColor: accessible ? `${mod.color}10` : 'transparent' }}>
                      <Icon
                        className={isWide ? 'w-5 h-5' : 'w-6 h-6'}
                        style={{ color: accessible ? mod.color : 'rgba(255,255,255,0.4)' }}
                        strokeWidth={2.2}
                      />
                    </div>
                    {!accessible && !mod.isApp && (
                      <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-white/20 rounded-full flex items-center justify-center">
                        <Lock className="w-3 h-3 text-white/60" />
                      </div>
                    )}
                  </div>
                  <div className={isWide ? 'text-left flex-1' : ''}>
                    <div className={`flex items-center ${isWide ? 'justify-start' : 'justify-center'} gap-1.5 mb-0.5`}>
                      <p className="text-xs font-semibold" style={{ color: accessible ? '#1e293b' : 'rgba(255,255,255,0.6)' }}>{mod.name}</p>
                      {mod.externalUrl && (mod.id === 'sges' || mod.id === 'acred_lab') && <ExternalLink className="w-3 h-3" style={{ color: accessible ? mod.color : 'rgba(255,255,255,0.4)' }} />}
                    </div>
                    {Array.isArray(mod.desc) ? (
                      <ul className="text-[9px] leading-tight list-disc list-inside space-y-0.5" style={{ color: accessible ? '#64748b' : 'rgba(255,255,255,0.35)' }}>
                        {mod.desc.map((item, i) => <li key={i}>{item}</li>)}
                      </ul>
                    ) : (
                      <p className="text-[9px] leading-tight" style={{ color: accessible ? '#64748b' : 'rgba(255,255,255,0.35)' }}>{mod.desc}</p>
                    )}
                    {mod.subdesc && accessible && (
                      <p className="text-[9px] font-semibold mt-0.5" style={{ color: mod.color }}>{mod.subdesc}</p>
                    )}
                    {(mod.areaResponsable || mod.contactos) && !isWide && (
                      <div className="mt-1.5 pt-1.5 border-t border-slate-200/70 space-y-1">
                        {mod.areaResponsable && (
                          <p className="text-[8px] font-bold uppercase tracking-wide leading-tight" style={{ color: accessible ? mod.color : 'rgba(255,255,255,0.4)' }}>
                            {mod.areaResponsable}
                          </p>
                        )}
                        {mod.empresaResponsable && (
                          <p className="text-[8px] font-semibold uppercase tracking-wide leading-tight" style={{ color: accessible ? '#64748b' : 'rgba(255,255,255,0.35)' }}>
                            Empresa: <span style={{ color: accessible ? mod.color : 'rgba(255,255,255,0.4)' }}>{mod.empresaResponsable}</span>
                          </p>
                        )}
                        {mod.contactos && mod.contactos.length > 0 && (
                          <div className="space-y-1">
                            {mod.contactos.map((c, idx) => {
                              const isObj = typeof c === 'object' && c !== null;
                              const nombre = isObj ? c.nombre : c;
                              return (
                                <div key={idx} className="leading-tight">
                                  <p className="text-[8.5px] font-semibold" style={{ color: accessible ? '#334155' : 'rgba(255,255,255,0.4)' }}>
                                    {nombre}
                                  </p>
                                  {isObj && (c.telefono || c.email) && accessible && (
                                    <div className="flex flex-col items-center gap-0.5 mt-0.5">
                                      {c.telefono && (
                                        <a
                                          href={`tel:${c.telefono.replace(/\s/g, '')}`}
                                          onClick={e => e.stopPropagation()}
                                          className="inline-flex items-center justify-center gap-1 text-[7.5px] text-slate-500 hover:text-slate-700 hover:underline"
                                          data-testid={`contact-phone-${mod.id}-${idx}`}
                                        >
                                          <Phone className="w-2 h-2" />
                                          <span>{c.telefono}</span>
                                        </a>
                                      )}
                                      {c.email && (
                                        <a
                                          href={`mailto:${c.email}`}
                                          onClick={e => e.stopPropagation()}
                                          className="inline-flex items-center justify-center gap-1 text-[7.5px] hover:underline"
                                          style={{ color: mod.color }}
                                          data-testid={`contact-email-${mod.id}-${idx}`}
                                        >
                                          <Mail className="w-2 h-2" />
                                          <span className="truncate max-w-[140px]">{c.email}</span>
                                        </a>
                                      )}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {mod.id === 10 && (
                    <div className="flex items-center gap-3 ml-auto">
                      <img src="/assets/adn-glencore-logo.png" alt="ADN Glencore" className="h-9 object-contain" />
                      <img src="/assets/safework-logo.png" alt="Safework" className="h-6 object-contain" />
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        </div>
        )}
      </div>

      <footer className="py-4 text-center">
        <p className="text-xs text-white/40">&copy; TystaCore {new Date().getFullYear()}</p>
      </footer>

      {/* Modal APP Pase Digital */}
      {showAppModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={() => setShowAppModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden" onClick={e => e.stopPropagation()} data-testid="app-modal">
            <div className="px-6 pt-6 pb-4 text-center" style={{ background: 'linear-gradient(135deg, #6C3D8E 0%, #8B5CF6 100%)' }}>
              <Fingerprint className="w-10 h-10 text-white mx-auto mb-2" />
              <h3 className="text-lg font-bold text-white">APP Pase Digital</h3>
              <p className="text-xs text-white/70 mt-1">Selecciona tu plataforma para descargar</p>
            </div>
            <div className="p-6 space-y-3">
              <a href="https://apps.apple.com/cl/app/credencial-digital-tysta/id6756027006" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 rounded-xl border-2 border-slate-200 hover:border-[#6C3D8E] hover:shadow-md transition-all group"
                data-testid="download-apple">
                <div className="w-12 h-12 bg-black rounded-xl flex items-center justify-center shrink-0">
                  <svg viewBox="0 0 24 24" className="w-7 h-7 text-white fill-current"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
                </div>
                <div>
                  <p className="text-[10px] text-slate-400 uppercase">Descargar en</p>
                  <p className="text-base font-bold text-slate-800 group-hover:text-[#6C3D8E] transition-colors">App Store</p>
                </div>
              </a>
              <a href="https://play.google.com/store/apps/details?id=cl.legav.pase_digital.tysta" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 rounded-xl border-2 border-slate-200 hover:border-[#6C3D8E] hover:shadow-md transition-all group"
                data-testid="download-android">
                <div className="w-12 h-12 bg-emerald-500 rounded-xl flex items-center justify-center shrink-0">
                  <svg viewBox="0 0 24 24" className="w-7 h-7 text-white fill-current"><path d="M17.523 15.341a.667.667 0 0 0 0-1.152l-1.665-.962 1.665-.962a.667.667 0 0 0 0-1.152L6.477 4.59a.667.667 0 0 0-1 .577v13.667a.667.667 0 0 0 1 .577l11.046-4.07zM3.5 2h1a.5.5 0 0 1 .5.5v19a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-19a.5.5 0 0 1 .5-.5z"/></svg>
                </div>
                <div>
                  <p className="text-[10px] text-slate-400 uppercase">Disponible en</p>
                  <p className="text-base font-bold text-slate-800 group-hover:text-[#6C3D8E] transition-colors">Google Play</p>
                </div>
              </a>
            </div>
            <div className="px-6 pb-5">
              <button onClick={() => setShowAppModal(false)} className="w-full py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg transition-colors" data-testid="close-app-modal">Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
